/**
 * Türkçe sözlük — DOĞRULUK KAYNAĞI.
 *
 * Diğer diller bu nesnenin şeklini uygulamak zorundadır (`Dictionary` tipi
 * buradan türetilir): eksik veya fazla bir anahtar derleme hatasıdır. Böylece
 * "çeviri unutuldu" durumu çalışma zamanında değil, derlemede yakalanır.
 *
 * Değişkenli metinler STRING BİRLEŞTİRME ile değil, FONKSİYON ile ifade edilir:
 *   ✗ `Derse {hours} saat kaldı`  → yer tutucu formatı her dilde ayrı ayrık
 *   ✓ (hours) => `Derse ${hours} saat kaldı`
 * Fonksiyon imzası tipe dahil olduğundan, bir dilde parametre unutulursa yine
 * derleme patlar. Ayrıca cümle yapısı dilden dile serbestçe değişebilir —
 * Türkçede sona gelen ek, İngilizcede başa gelen edat olabilir.
 *
 * `as const` BİLİNÇLİ OLARAK KULLANILMADI: literal tipe daraltsaydı `en`
 * sözlüğü aynı Türkçe metinleri yazmak zorunda kalırdı.
 */
export const tr = {
  common: {
    save: 'Kaydet',
    cancel: 'Vazgeç',
    close: 'Kapat',
    confirm: 'Onayla',
    ok: 'Tamam',
    loading: 'Yükleniyor…',
    retry: 'Tekrar dene',
    currencySuffix: '₺',
  },

  a11y: {
    mainNavigation: 'Ana gezinme',
    sections: 'Bölümler',
    logout: 'Çıkış yap',
    checkingSession: 'Oturum kontrol ediliyor',
    languageSwitcher: 'Dil seçimi',
    themeSwitcher: 'Görünüm teması',
    homeLink: 'Zee Sports Studio ana sayfa',
  },

  theme: {
    system: 'Sistem',
    light: 'Aydınlık',
    dark: 'Koyu',
  },

  roles: {
    ADMIN: 'Firma Sahibi',
    INSTRUCTOR: 'Eğitmen',
    CLIENT: 'Üye',
  },

  nav: {
    CALENDAR: 'Ders Programı',
    PACKAGES: 'Paketlerim',
    TRAINER: 'Kayıtlar & Paketler',
    ADMIN: 'Yönetim & Raporlar',
    PROFILE: 'Profilim',
  },

  navShort: {
    CALENDAR: 'Program',
    PACKAGES: 'Paketlerim',
    TRAINER: 'Kayıtlar',
    ADMIN: 'Yönetim',
    PROFILE: 'Profilim',
  },

  shortcuts: {
    title: 'Klavye kısayolları',
    search: 'Takvimde aramaya odaklan',
    goHint: (key: string) => `g sonra ${key}`,
    help: 'Bu listeyi aç',
    close: 'Pencereyi kapat',
  },

  auth: {
    tagline: 'Reformer, mat ve fonksiyonel antrenman stüdyosu. Programınız için giriş yapın.',
    methodTablist: 'Giriş yöntemi',
    login: 'Giriş Yap',
    register: 'Üye Ol',
    createAccount: 'Hesap Oluştur',
    email: 'E-Posta',
    emailPlaceholder: 'ornek@eposta.com',
    identifier: 'E-posta veya telefon',
    identifierPlaceholder: 'ornek@eposta.com ya da 05XX XXX XX XX',
    password: 'Şifre',
    passwordHint:
      'En az 8 karakter; bir büyük harf, bir küçük harf, bir rakam ve bir özel karakter içermeli.',
    fullName: 'Ad Soyad',
    fullNamePlaceholder: 'Selin Yılmaz',
    phone: 'Telefon',
    phonePlaceholder: '0532 555 12 34',
    cookieNotice: 'Oturumunuz httpOnly çerezle korunur',
    forgotLink: 'Şifremi unuttum',
    forgotTitle: 'Şifreni mi unuttun?',
    forgotBody:
      'E-posta adresini gir; hesabın kayıtlıysa şifre sıfırlama bağlantısı gönderelim.',
    forgotSubmit: 'Sıfırlama bağlantısı gönder',
    forgotSent:
      'E-posta adresin kayıtlıysa, şifre sıfırlama bağlantısını gönderdik. Gelen kutunu — ve spam klasörünü — kontrol et. Bağlantı 30 dakika geçerli.',
    backToLogin: 'Girişe dön',
    resetTitle: 'Yeni şifre belirle',
    resetBody: 'Hesabın için yalnızca senin bileceğin yeni bir şifre seç.',
    newPasswordLabel: 'Yeni Şifre',
    resetSubmit: 'Şifreyi güncelle',
    resetInvalid: 'Sıfırlama bağlantısı geçersiz veya süresi dolmuş.',
    resetRequestNew: 'Yeni bağlantı iste',
  },

  passwordRotation: {
    title: 'Şifrenizi Belirleyin',
    description:
      'Hesabınız stüdyo yönetimi tarafından geçici bir şifreyle açıldı. Devam etmeden önce yalnızca sizin bildiğiniz bir şifre belirlemelisiniz.',
    currentPassword: 'Geçici Şifre',
    currentPasswordHint: 'Size iletilen tek kullanımlık şifre.',
    newPassword: 'Yeni Şifre',
    submit: 'Şifremi Güncelle',
    success: 'Şifreniz güncellendi.',
    signOut: 'Vazgeç ve çıkış yap',
  },

  /* Hesap ayarları — navbar'daki kullanıcı adına tıklayınca açılan pencere.
     Şifre değişimi rotasyon ekranıyla aynı ucu kullanır ama metinleri farklı:
     burada "geçici şifre" yok, kullanıcı kendi bildiği şifreyi değiştiriyor. */
  account: {
    title: 'Hesap Ayarları',
    open: 'Profilime git',
    emailLabel: 'E-posta',
    emailHint: 'E-posta giriş kimliğinizdir; panelden değiştirilemez.',
    phoneLabel: 'Telefon',
    changePasswordTitle: 'Şifre Değiştir',
    changePasswordDescription:
      'Şifreniz değiştiğinde diğer cihazlardaki oturumlarınız güvenlik için kapatılır.',
    currentPassword: 'Mevcut Şifre',
    newPassword: 'Yeni Şifre',
    submit: 'Şifremi Güncelle',
    appearanceTitle: 'Görünüm ve Dil',
    themeLabel: 'Tema',
    languageLabel: 'Dil',
  },

  /* Ders Programı — tek takvim (üye yüzü). */
  schedule: {
    title: 'Ders Programı',
    memberSubtitle: 'Paketlerinizden planlanan dersleriniz.',
    staffSubtitle: 'Stüdyonun tüm dersleri — paket, üye, eğitmen ve salon.',
    previousWeek: 'Önceki hafta',
    nextWeek: 'Sonraki hafta',
    today: 'Bugün',
    viewModeLabel: 'Görünüm',
    viewWeek: 'Hafta',
    viewList: 'Liste',
    daysLabel: 'Haftanın günleri',
    loading: 'Ders programı yükleniyor',
    loadError: 'Ders programı yüklenemedi.',
    emptyDay: 'Ders yok',
    dayCount: (count: number) => `${count} ders`,
    emptyMemberTitle: 'Bu hafta dersiniz yok',
    emptyMemberBody:
      'Dersleriniz, eğitmeniniz paketinizi planladıkça burada görünür. Diğer haftalara oklarla geçebilirsiniz.',
    lessonOf: (current: number, total: number) => `Ders ${current}/${total}`,
    seats: (count: number, capacity: number) => `${count}/${capacity} kişi`,
    more: (count: number) => `+${count}`,
    cancelled: 'İptal edildi',
    rescheduled: 'Kaydırıldı',
    makeupLesson: 'Telafi',
    trainer: 'Eğitmen',
    room: 'Salon',
    time: 'Saat',
    packageLabel: 'Paket',
    detailTitle: 'Ders ayrıntısı',
    attendance: {
      PRESENT: 'Geldi',
      LATE: 'Geç kaldı',
      ABSENT: 'Gelmedi',
      EXCUSED: 'Mazeretli',
    },
    attendancePending: 'Yoklama bekleniyor',
    makeupUsed: 'Mazeret hakkı kullanıldı',
    makeupNotice: (hours: number) =>
      `Gelemeyecekseniz dersten en az ${hours} saat önce buradan mazeret bildirin; eğitmeninize haber gider.`,
    makeupClosed: (hours: number) =>
      `Derse ${hours} saatten az kaldı; gelemeyecekseniz eğitmeninize haber verin.`,
    makeupRequest: 'Mazeret bildir',
    makeupConfirm: 'Bu derse gelemeyeceğinizi bildiriyorsunuz; mazeret hakkınızdan bir düşer.',
    makeupConfirmButton: 'Evet, bildir',
    makeupRights: (used: number, allowed: number) => `Mazeret hakkı: ${used}/${allowed}`,
    makeupExhausted: 'Mazeret hakkınız doldu; gelemeyecekseniz eğitmeninize haber verin.',
    makeupDone: 'Mazeretiniz alındı; eğitmeninize bildirildi.',
  },

  /* Paketlerim — üyenin paketleri (fiyatsız). */
  myPackages: {
    title: 'Paketlerim',
    subtitle: 'Paketleriniz stüdyoda tanımlanır; ilerlemenizi ve mazeret hakkınızı buradan izleyin.',
    loading: 'Paketleriniz yükleniyor',
    loadError: 'Paketleriniz yüklenemedi.',
    emptyTitle: 'Henüz paketiniz yok',
    emptyBody:
      'Paketler stüdyoda satın alınır ve eğitmeniniz tarafından hesabınıza tanımlanır. Tanımlandığında dersleriniz burada ve Ders Programı’nda görünür.',
    status: {
      ACTIVE: 'Devam ediyor',
      COMPLETED: 'Tamamlandı',
      CANCELLED: 'İptal edildi',
    },
    groupBadge: 'Grup dersi',
    progressLabel: 'Paket ilerlemesi',
    done: (count: number, total: number) => `${count}/${total} ders yapıldı`,
    upcoming: (count: number) => `${count} ders planlandı`,
    unscheduled: (count: number) => `${count} ders planlanacak`,
    absences: (used: number, allowed: number) => `Mazeret hakkı ${used}/${allowed}`,
    noAbsences: 'Bu pakette mazeret hakkı yok',
    plan: 'Plan',
    trainer: 'Eğitmen',
    room: 'Salon',
    started: 'Başlangıç',
    validUntil: 'Son geçerlilik',
    nextLesson: 'Sıradaki ders',
    noNextLesson: 'Planlanmış ders yok',
  },

  /* Profilim — hesap, görünüm, sağlık notları, sözleşme, görünüm geçişi. */
  profile: {
    title: 'Profilim',
    subtitle: 'Hesabınız, görünüm tercihleriniz ve üyelik bilgileriniz.',
    accountTitle: 'Hesap',
    healthTitle: 'Postür & Sağlık Notları',
    healthDescription: 'Eğitmeniniz dersi bu notlara göre planlar.',
    goalLabel: 'Hedefiniz',
    goalEmpty: 'Henüz hedef belirtilmedi.',
    goalPlaceholder: 'Örn: Core güçlendirme & postür düzeltme',
    notesLabel: 'Sakatlık / Duruş Notları',
    notesEmpty: 'Eğitmeniniz için henüz özel sakatlık / duruş notu girmediniz.',
    notesPlaceholder: 'Örn: Hafif L5-S1 bel hassasiyeti, sağ omuz gerginliği',
    notesHint: 'Bu bilgi yalnızca sizin ve eğitmenlerinizin görebileceği sağlık verisidir.',
    healthEdit: 'Notları düzenle',
    healthAdd: 'Sağlık notu ekle',
    agreementTitle: 'Üyelik Sözleşmesi',
    agreementSigned: (name: string, date: string, version: string) =>
      `${name} tarafından ${date} tarihinde onaylandı · sürüm ${version}`,
    agreementOutdated: 'Sözleşme güncellendi; bir sonraki girişinizde yeni metni onaylamanız istenecek.',
    agreementNone: 'Kayıtlı bir onay bulunamadı.',
    agreementRead: 'Sözleşmeyi oku',
    previewNotice: 'Önizlemedesiniz: hesap ayarları ve sağlık notları üyenin kendi ekranında görünür.',
  },

  /* Üyelik sözleşmesi kapısı. */
  agreement: {
    title: 'Üyelik Sözleşmesi',
    intro:
      'Derslere başlamadan önce stüdyonun üyelik sözleşmesini okuyup onaylamanız gerekiyor. Onayınız adınız ve tarihle birlikte kaydedilir.',
    readHint: 'Metni sonuna kadar okuyun.',
    readDone: 'Metnin sonuna geldiniz.',
    nameLabel: 'Ad Soyad',
    nameHint: '18 yaşından küçük üyeler için velinin adı soyadı.',
    nameError: 'Adınızı ve soyadınızı yazın (en az 3 karakter).',
    dateLabel: 'Tarih',
    accept: 'Sözleşmeyi okudum, anladım ve onaylıyorum.',
    submit: 'Onayla ve devam et',
    signOut: 'Çıkış yap',
    version: (version: string) => `Sözleşme sürümü: ${version}`,
    turkishOnly: '',
  },

  /* Yönetici önizlemesi şeridi. */
  viewAs: {
    banner: (name: string, role: string) => `${name} (${role}) olarak görüntülüyorsunuz`,
    exit: 'Kendi görünümüme dön',
  },

  instructorModal: {
    dayNames: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
    experience: (years: number) => `${years} yıl deneyim`,
    pt: 'Birebir PT',
    group: 'Grup Dersleri',
    certifications: 'Sertifikalar',
    weeklyProgram: 'Haftalık Program',
    reviews: 'Üye Yorumları',
  },

  errorFallback: {
    title: 'Bir şeyler ters gitti',
    body: 'Beklenmeyen bir hata oluştu. Sayfayı yenilemek çoğu durumda sorunu çözer.',
    supportCode: (id: string) => `Destek kodu: ${id}`,
    retry: 'Tekrar Dene',
    reload: 'Sayfayı Yenile',
    panelTitle: 'Bu bölüm yüklenemedi',
    unknown: 'Bilinmeyen hata',
  },

  errors: {
    network: 'Sunucuya ulaşılamıyor. İnternet bağlantınızı kontrol edip tekrar deneyin.',
    unexpected: 'Beklenmeyen bir hata oluştu.',
    unexpectedResponse: 'Sunucudan beklenmeyen bir yanıt alındı.',
  },

  footer: {
    studioName: 'Zee Sports Studio',
    copyright: '© 2026',
    tags: ['Reformer', 'Birebir', 'Fonksiyonel'],
  },
};
